import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './StatCard.scss';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../utils/formatCurrency';

function StatCard({ title, count, revenue, icon, color, currency = 'EUR' }) {
  return (
    <Card className="h-100 stat-card">
      <Card.Body className="d-flex align-items-center">
        <div className={`icon-wrapper bg-${color} bg-opacity-10 rounded-circle me-3`}>
          <FontAwesomeIcon icon={icon} className={`text-${color}`} />
        </div>
        <div>
          <h6 className="mb-1">{title}</h6>
          <div className="d-flex flex-column">
            <span className="h4 mb-0">{count}</span>
            <small className="text-muted">{formatCurrency(revenue, currency)}</small>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  revenue: PropTypes.number.isRequired,
  icon: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  currency: PropTypes.string
};

export default StatCard; 